import React, { useEffect, useState } from 'react';
import './Email.css';

const Email = () => {
  const [emails, setEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [replyMessage, setReplyMessage] = useState("");
  const [replySubject, setReplySubject] = useState("");

  // Fetch emails on mount
  useEffect(() => {
    fetch('https://prod-erp.nifty10.in/api/emails')
      .then(res => res.json())
      .then(data => {
        const formatted = data.map((email, i) => ({
          id: i,
          sender: email.from,
          subject: email.subject,
          preview: email.text?.slice(0, 100) || '',
          fullText: email.html || email.text,
          time: new Date(email.date).toLocaleString()
        }));
        setEmails(formatted);
      })
      .catch(err => console.error("Error fetching emails:", err));
  }, []);

  const sendReply = () => {
    if (!selectedEmail) return;

    fetch('https://prod-erp.nifty10.in/api/email/reply', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        to: selectedEmail.sender,
        subject: replySubject || `Re: ${selectedEmail.subject}`,
        html: replyMessage
      })
    })
      .then(res => res.json())
      .then(data => {
        alert('✅ Reply sent!');
        setReplyMessage("");
        setReplySubject("");
        setSelectedEmail(null);
      })
      .catch(err => {
        console.error("Reply error:", err);
        alert("❌ Failed to send reply.");
      });
  };

  return (
    <div className="email-container">
      {/* <div className="email-sidebar">
        <div className="email-sidebar-logo">📧</div>
        <div className="email-sidebar-icon active">📥</div>
        <div className="email-sidebar-icon">📤</div>
        <div className="email-sidebar-icon">🗑️</div>
        <img className="email-sidebar-avatar" src="https://i.pravatar.cc/40" alt="User" />
      </div> */}

      <div className="email-main">
        <div className="email-header">
          <input className="email-search-input" placeholder="Search Email..." />
          <div className="email-header-icon">🔔</div>
          <div className="email-header-avatar-placeholder" />
        </div>

        <div className="email-content">
          <div className="email-sidebar-menu">
            <button className="email-btn-compose">+ New Message</button>
            <div className="email-sidebar-section-title">MAILBOXES</div>
            <div className="email-mailbox-item inbox">Inbox <span className="count">{emails.length}</span></div>
            <div className="email-mailbox-item">Sent</div>
            <div className="email-mailbox-item">Trash</div>
          </div>

          <div className="email-list-section">
            {/* <div className="email-list-header">
              <input className="email-list-search-input" placeholder="Search here..." />
              <button className="email-list-btn">Chat</button>
              <button className="email-list-btn">Video</button>
            </div> */}

            <div className="email-list-container">
              {emails.map((mail, i) => (
                <div
                  key={mail.id}
                  className={`email-item ${selectedEmail?.id === mail.id ? "selected" : ""}`}
                  onClick={() => setSelectedEmail(mail)}
                >
                  <input type="checkbox" className="email-item-checkbox" />
                  <div className="email-item-content">
                    <div className="email-item-sender">{mail.sender}</div>
                    <div className="email-item-subject">{mail.subject}</div>
                    <div className="email-item-preview">{mail.preview}</div>
                  </div>
                  <div className="email-item-time">{mail.time}</div>
                </div>
              ))}
            </div>

            {selectedEmail && (
              <div style={{ marginTop: 20, padding: 16, background: "#fff", borderRadius: 12 }}>
                <h3>Replying to: <b>{selectedEmail.sender}</b></h3>
                <p><b>Subject:</b> {selectedEmail.subject}</p>
                <div dangerouslySetInnerHTML={{ __html: selectedEmail.fullText }} style={{ margin: "12px 0" }} />

                <input
                  type="text"
                  value={replySubject}
                  onChange={e => setReplySubject(e.target.value)}
                  placeholder="Reply Subject"
                  style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: 8, border: '1px solid #ccc' }}
                />

                <textarea
                  rows={6}
                  value={replyMessage}
                  onChange={e => setReplyMessage(e.target.value)}
                  placeholder="Type your reply here..."
                  style={{ width: '100%', padding: '10px', marginBottom: '10px', borderRadius: 8, border: '1px solid #ccc' }}
                />

                <button onClick={sendReply} className="email-btn-compose" style={{ width: 'auto' }}>
                  📤 Send Reply
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Email;